module.exports = __webpack_public_path__ + "img/bg-share-code.e843d452.png";